import React from "react";
import { Outlet } from "react-router-dom";

const Auth = () => {
  sessionStorage.clear();
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default Auth;
